<template>
    <div>
        <div class="top flex items-center justify-between mb-8">
            <h1>Sort products</h1>
            <AppButton
                :loading="loading"
                label="Update"
                @click="updateSortOrder()"
            />
        </div>
        <draggable
            v-model="products"
        >
            <div
                v-for="product in products"
                :key="product.id"
                class="product"
            >
                {{ product.title }} - {{ product.article_number }}
            </div>
        </draggable>
        <Spinner v-if="!loaded"/>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import AppButton from '../../components/ui/AppButton.vue';
import Spinner from '../../components/ui/Spinner.vue';
import { get, update } from '../../utils/apiHelper';

export default {
    components: {
        draggable,
        AppButton,
        Spinner,
    },
    data: () => ({
        products: [],
        loading: false,
        loaded: false,
    }),
    async created() {
        this.products = await get('/api/products/all', { order: 'sort_order' });
        this.loaded = true;
    },
    methods: {
        async updateSortOrder() {
            this.loading = true;

            const products = this.products.map((product, index) => ({
                id: product.id,
                sort_order: index + 1,
            }));

            await update('/api/products/sort-order', { products });

            this.loading = false;
        },
    },
};
</script>

<style lang="postcss" scoped>
.product {
    padding: 8px 15px;
    font-size: 14px;
    background-color: #fff;
    margin-bottom: 5px;
}
</style>
